import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Drawer from "@mui/material/Drawer";
import { Link } from "react-router-dom";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function IdleTimeOutModal(props) {
  const { open, setOpen } = props;
  const handleRefresh = () => {
    setOpen(false);
    window.location.reload();
    window.location.href = "/auth/login";
  };

  return (
    <div>
      <Dialog
        fullWidth
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleRefresh}
        aria-describedby="alert-dialog-slide-description"
      >
        <Card sx={{ minWidth: 200 }}>
          <CardContent>
            <Typography
              sx={{ fontSize: 14, textAlign: "center" }}
              color="text.secondary"
              gutterBottom
            >
              Successfully Registered
            </Typography>
            <div className="text-center mb-3">
              <img
                style={{
                  width: "50%",
                  height: "50%",
                  //class: "center",
                  marginLeft: "auto",
                  marginRight: "auto",
                  display: "block",
                }}
                alt="..."
                src={require("../../assets/img/AutomateCIS_logo.svg").default}
              />
            </div>
            <Drawer />
            <p style={{ lineHeight: "4.7", textAlign: "center" }}>
              Please verify the email to login
            </p>
            <div className="col text-right" style={{ textAlignLast: "center" }}>
              <Button
                className="text-blueGray-200"
                variant="contained"
                onClick={handleRefresh}
              >
                Log in
              </Button>
            </div>
          </CardContent>
        </Card>
      </Dialog>
    </div>
  );
}
